import { CSSProperties } from "react" ;
import { HFTResults } from "./HFTResults";

export class HftBreakdownResults {
  private defaultColor: CSSProperties = { backgroundColor: "#EEEEEE" };
  private passColor: CSSProperties = { backgroundColor: "#00FF00" };
  private failColor: CSSProperties = { backgroundColor: "#FF0000" };

  constructor(hftResults: HFTResults, hftTarget?: number) {
    if (hftResults == null) {
      return;
    }

    if (hftResults.inputs != null) {
      this.hftIn.value = hftResults.inputs.toString();
      this.hftIn.style = hftResults.inputs >= hftTarget
        ? this.passColor
        : this.failColor;
    }
    if (hftResults.logicSolver != null) {
      this.hftLs.value = hftResults.logicSolver.toString();
      this.hftLs.style = hftResults.logicSolver >= hftTarget
        ? this.passColor
        : this.failColor;
    }
    if (hftResults.actions != null) {
      this.hftAct.value = hftResults.actions.toString();
      this.hftAct.style = hftResults.actions >= hftTarget
        ? this.passColor
        : this.failColor;
    }
    if (hftResults.support1 != null) {
      this.hftSpt1.value = hftResults.support1.toString();
      this.hftSpt1.style = hftResults.support1 >= hftTarget
        ? this.passColor
        : this.failColor;
    }
    if (hftResults.support2 != null) {
      this.hftSpt2.value = hftResults.support2.toString();
      this.hftSpt2.style = hftResults.support2 >= hftTarget
        ? this.passColor
        : this.failColor;
    }
    if (hftResults.manualInputs != null) {
      this.hftMin.value = hftResults.manualInputs.toString();
      this.hftMin.style = hftResults.manualInputs >= hftTarget
        ? this.passColor
        : this.failColor;
    }
    if (hftResults.manualAction != null) {
      this.hftMact.value = hftResults.manualAction.toString();
      this.hftMact.style = hftResults.manualAction >= hftTarget
        ? this.passColor
        : this.failColor;
    }
  }

  public hftIn =      { value: "", style: this.defaultColor };
  public hftInStyle = { value: "", style: this.defaultColor };
  public hftLs =      { value: "", style: this.defaultColor };
  public hftAct =     { value: "", style: this.defaultColor };
  public hftSpt1 =    { value: "", style: this.defaultColor };
  public hftSpt2 =    { value: "", style: this.defaultColor };
  public hftMin =     { value: "", style: this.defaultColor };
  public hftMact =    { value: "", style: this.defaultColor };
}